export default __webpack_public_path__ + "static/media/father-child.06ea8fdb.jpg";